import axios from 'axios'

// URL de tu backend Laravel
const api = axios.create({
  baseURL: 'http://vps-5436570-x.dattaweb.com:8080/api', // <-- Cambiá por la URL de tu backend
  //withCredentials: true, // clave para Sanctum si usás cookies
  headers: {
    //'Accept': 'application/json',
    //'Content-Type': 'application/json'
    'Content-Type': 'multipart/form-data' 
  }
})

// Agregar token Bearer automáticamente si existe en localStorage
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default api
